import { Alert, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import variables from "../../../styles/utils.module.scss";
import CheckboxWithLabel from "../../../components/CheckboxWithLabel";
import axios from "axios";
import { getMessagesUserType, serverUrl } from "../../../helpers/utility";
import { mutate } from "swr";
import InputWithLabel from "../../../components/inputWithLabel";
import InputWithSelect from "../../../components/inputWithSelect";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function ConfirmEnquiryModal({ enquiry, placement, location, show, close, size, user }) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
  } = useForm();
  const formValues = watch();
  const [sent, markSent] = useState(false);
  const [skipReporting, setSkipReporting] = useState(false);
  const [enquiryData, setEnquiryData] = useState(null);
  let navigate = useNavigate();

  // Frequency options for the dropdown
  const frequencyOptions = [
    { value: "per_week", label: "Per Week" },
    { value: "per_month", label: "Per Month" },
  ];

  if (typeof close !== "function") {
    console.error(`CompleteEnquiryModal missing close function!`);
    return <></>;
  }

  useEffect(() => {
    return () => {
      resetModal();
    };
  }, []);

  function resetModal() {
    markSent(false);
    setEnquiryData(null);
    reset();
  }

  async function sendCompleteEnquiry() {
    let validationOK = await trigger(); 

    if (!validationOK && !skipReporting) {
      console.error(`Validation failed`);
      return;
    }

    try {
      const response = await axios.put(`${serverUrl}/enquiry`, {
        _id: enquiry?._id,
        placementId: placement._id,
        careProviderLocationId: location._id,
        careProviderOrganisationId: location.careProviderOrganisationId,
        completed: true,
      });

      const placementCost = {
        amount: formValues.amount,
        frequency: formValues.frequency,
      };

      await axios.put(`${serverUrl}/placement`, {
        _id: placement._id,
        hasBeenPlaced: true,
        status: "COMPLETED",
        cost: placementCost,
        placementDate: new Date(),
        careProviderLocationId: location._id,
        careProviderOrganisationId: location.careProviderOrganisationId,
      });

      const now = new Date();
      const periodKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
      await axios.put(`${serverUrl}/insight/${user.localAuthorityId}`, {
        localAuthorityId: user.localAuthorityId,
        periodKey: periodKey,
        periodType: "monthly",
        completedPlacements: [placement._id],
      });

      if (response && response?.data?.result?._id) {
        markSent(true);
        setEnquiryData(response.data.result);
        close();
      }
    } catch (error) {
      console.error(`Complete enquiry error: ${error}`);
      close();
    }
  }

  return (
    <Modal show={show} onHide={close} size={size || "lg"} centered>
      <Modal.Header closeButton>
        <Modal.Title>Complete Enquiry</Modal.Title>
      </Modal.Header>

      {!sent ? (
        <>
          <Modal.Body>
            <Form>
              <p>
                When completing an enquiry bPlaced ask that you record the cost and date of
                placement. <br /> This data will be used to display the average cost & time taken
                for placements in the <a href="/dashboard/insights">Insights section</a>.
              </p>
              <div className="row gx-3">
                <div className="col-md-4">
                  <InputWithLabel
                    disabled={skipReporting}
                    wrapperClass={skipReporting ? "opacity-50" : ""}
                    inputId={`amount`}
                    label={`Amount (£)`}
                    placeholder={`Enter amount`}
                    type="number"
                    inputProps={{ min: 0, step: 0.01 }}
                    register={register}
                    validation={{ required: true }}
                    error={errors.amount}
                    errorMessage="Amount is required"
                  />
                </div>
                <div className="col-md-4">
                  <InputWithSelect
                    disabled={skipReporting}
                    wrapperClass={skipReporting ? "opacity-50" : ""}
                    inputId={`frequency`}
                    label={`Frequency (per week or per month)`}
                    options={frequencyOptions}
                    register={register}
                    validation={{ required: true, validate: (value) => value !== "-1" }}
                    error={errors.frequency}
                    errorMessage="Frequency is required"
                  />
                </div>
                <div className="col-md-4">
                  <InputWithLabel
                    inputId={`dateCompleted`}
                    label={`Date Completed`}
                    placeholder={`Enter date completed`}
                    type="date"
                    inputProps={{ value: new Date().toISOString().split("T")[0] }}
                    register={register}
                    validation={{ required: true }}
                    error={errors.dateCompleted}
                    errorMessage="Date completed is required"
                  />
                </div>
              </div>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button className="me-auto" variant="outline-dark" onClick={() => setSkipReporting(true)}>
              Skip Reporting?
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                close();
                resetModal();
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={sendCompleteEnquiry}>
              Complete Enquiry
            </Button>
          </Modal.Footer>
        </>
      ) : null}
    </Modal>
  );
}

export default ConfirmEnquiryModal;
